var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"time-bar"},[_c('div',{staticClass:"bar-inner",class:{
      'bg-success': _vm.currentPercentage > 80,
      'bg-info': _vm.currentPercentage > 20,
      'bg-danger': _vm.currentPercentage <= 20,
    },style:({ width: _vm.currentPercentage + '%' })},[_c('div',{staticClass:"time-label"},[_vm._v(" "+_vm._s(_vm.currentTime)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }